module.exports = __webpack_public_path__ + "static/media/box-number-win.0276c135.png";